import Vue from 'vue';

const ConstPlugin = {
    install(Vue, options) {
        Vue.prototype.$CONST = {
            COMMON: {
                LANGUAGE: {
                    1: "zh",
                    2: "en",
                    3: "ja",
                    4: "vi"
                },
                NUMBER: {
                    ZERO:   0,
                    ONE:    1,
                    TWO:    2,
                    THREE:  3,
                    FOUR:   4,
                    FIVE:   5,
                    TWENTY_FIVE: 25,
                    TWENTY_SIX: 26,
                    FORTY: 40,
                    ONE_HUNDRED: 100
                },
                STRING: {
                    IS_BLANK: "",
                    IS_NULL: null,
                    IS_INVALID: undefined,
                    STRIKE_THROUGH: '—'
                }
            },
            CURRICULUM: {
                INFO: {
                    // Đã đăng ký kết thúc khóa học
                    FINISHED: {
                        OK: 1,
                        NOT: 0
                    },
                    EXAMCLICK: {
                        LEARNING_NOT_COMPLETED: 0,
                        CAN_TAKE_EXAM: 1,
                        NONE_INFO_EXAM: 2,
                        UNSCORED: 3
                    },
                    INCORRECT_ANSWER: {
                        HAVE: 1,
                        NONE: 0
                    },
                    LOCKED: {
                        OK: "1",
                        NOT: "0"
                    }
                },
                EXAM: {
                    STATUS: {
                        NOT_ACTIVATED: 0,
                        UNSCORED: 1,
                        SCORED: 2,
                        DONE: 3,
                        FINISHED: 4,
                        NONE: 9
                    }
                },
                COMPONENTS: {
                    WEEK: 'week',
                    SCHEDULEWEEK: 'scheduleWeek'
                }
            },
            CURRICULUM_EXAM: {
                STATUS: {
                    MIDTERM: {
                        NOT_START_OR_SUCCESS: 0,
                        DOING: 1,
                        GRADING: 2
                    }
                }
            },
            VIDEO: {
                CONTENT_TYPE: {
                    MENU: 'MENU',
                    NOTEBOOK: 'NOTEBOOK',
                    MESSENGER: 'MESSENGER'
                },
                CHAT: {
                    USER_TYPE: {
                        ME: 1,
                        TEACHER: 3,
                        ORTHER: 2
                    }
                },
                MENU: {
                    IS_TITLE: 1,
                    LEARNING_COMPLETED: 0,
                    LEARNING: 2,
                    HAVE_EXERCISE: 0,
                    EXERCISE_NONE: 0
                },
                MATERIAL: {
                    TYPE: {
                        VIDEO: 1,
                        PDF: 2,
                        IMG: 3,
                        YOUTUBE: 4,
                    }
                }
            },
            MENU: {
                IS_TITLE: 1,
                LEARNING_COMPLETED: 0,
                LEARNING: 2,
                HAVE_EXERCISE: 0,
                EXERCISE_NONE: 0,
                EXERCISE_FINISHED: 1,
                EXERCISE_SENT: 2,
                MIN_PERCENT: 0,
                MAX_PERCENT: 100,
                MAX_WIDTH_STROKE_PROGESS: 26,
                TYPE: 2
            },
            HEADER: {
                ITEM: {
                    HOME: "HOME",
                    SCHOOLBUSINESS: "SCHOOLBUSINESS",
                    CONDITIONS: "CONDITIONS",
                    PERFORMANCE: "PERFORMANCE",
                    LIVE: "LIVE",
                    OPERATION: 'operation',
                    FAQ: 'faq',
                    PROTOCOL: 'protocol',
                    POLICY: 'policy',
                    ANALYSIS: 'ANALYSIS',
                    MANAGE_STUDENT: 'MANAGE_STUDENT',
                    MANAGE_LESSON: 'MANAGE_LESSON',
                    MANAGE_ATTENDANCE: 'MANAGE_ATTENDANCE',
                    SUPPORT: 'SUPPORT',
                    NOTIFICATION: 'NOTIFICATION'
                },
                ROUTER: {
                    HOME: '/home/index',
                    HOMEPARENT: '/home',
                    LIVE: '/home/live/course',
                    HOMEPARENTPARENT: '/home/home/index',
                    SCHOOLBUSINESS: '/home/SchoolBusiness_new',
                    SCHOOLBUSINESS_VN: '/home/SchoolBusiness_new',
                    SCHOOLBUSINESS_SCHEDULE: '/home/scheduleSchoolBusiness',
                    CONDITIONS: '/home/studySituationList',
                    PERFORMANCE: '/home/courseScoreStatistics',                    
                    SCHCONDITIONS: '/home/schStudySituationList',
                    SCHPERFORMANCE: '/home/schCourseScoreStatistics',  
                    PERSONSET: '/home/personSet',
                    SEARCH: '/home/search',
                    OPERATION: "/home/manual",
                    FAQ: "/home/faq_new",
                    MANAGE_STUDENT: '/home/manage/students',
                    MANAGE_LESSON: '/home/manage/lessons',
                    MANAGE_ATTENDANCE: '/home/manage/attendances',
                    CURRICULUM: '/home/curriculum',
                    AICOURSE: '/home/Aicourse'
                },
                IMG_ITEM: {
                    SCHOOLBUSINESS: "/static/images/khoahoccuatoi-trang.png",
                    SCHOOLBUSINESS_ACTIVE: "/static/images/khoahoccuatoi-trang-hover.png",
                    ANALYSIS: "/static/images/tinhhinhht-trang.png",
                    ANALYSIS_ACTIVE: "/static/images/tinhhinhht-trang-hover.png",
                    LIVE: "/static/images/baigiangonline-trang.png",
                    LIVE_ACTIVE: "/static/images/baigiangonline-trang-hover.png",
                    HOME: "/static/images/home-trang.png",
                    HOME_ACTIVE: "/static/images/home-trang-hover.png",
                    NOTIFICATION: "/static/images/notification.png",
                    NOTIFICATION_ACTIVE: "/static/images/notification_active.png"
                },
                IMG: {
                    LOGO: '/static/images/logo-jp.png',
                    CLOSE: '/static/images/close.png',
                    SEARCH: '/static/images/timkiem-trang.png',
                    CONDITIONS: '/static/images/icon-studySituation.png',
                    PERFORMANCE: '/static/images/icon-scoreStatistic.png',
                    MENU: '/static/images/icon-menu.png',
                    QUITE: '/static/images/quite.png',
                    LOGIN: '/static/images/login.png',
                    OPERATION: '/static/images/home_opre.png',
                    FAQ: '/static/images/home_faq.png',
                    PROTOCOL: '/static/images/home_service.png',
                    POLICY: '/static/images/home_policy.png',
                    MANAGE_STUDENT: '/static/images/icon-studentManager.png',
                    MANAGE_LESSON: '/static/images/icon-lessonManager.png',
                    MANAGE_ATTENDANCE: '/static/images/icon-QLDD-trang.png',
                    PROFILE: '/static/images/icon-profile.png',
                    EN: '/static/images/en.png',
                    ZH: '/static/images/zh.png',
                    JA: '/static/images/ja.png',
                    VI: '/static/images/vi.png',
                    SUPPORT: '/static/images/support.png',
                    CONDITIONS_SCHEDULE: '/static/images/IC-TTKH-schedule.png',
                    PERFORMANCE_SCHEDULE: '/static/images/IC-TTHT-schedule.png',
                },
                LANGUAGE: {
                    ZH: "zh",
                    EN: "en",
                    JA: "ja",
                    VI: "vi"
                }
            },
            MANAGE: {
                STATICTICAL: {
                    COLUMNS: {
                        NAME: "name",
                        PERCENT: "percent"
                    },
                    LINE: {
                        GRADES: "grades",
                        SCORE: "score",
                        SERIES: {
                            STYLE: {
                                COLORLIST : ["#65d186",  "#f67287", "#f29e3c", "#c05bdd"]
                            },
                            NAME: "point",
                            TYPE: "bar",
                            WIDTH: "50%"
                        }
                    }
                },
                TYPE: {
                    STUDENT: 1,
                    LESSON: 0,
                    ATTENDANCE: 2
                }
            },
            DOMAIN: {
                TDMU: {
                    COMPANY_NAME: 'Trường đại học Thủ Dầu Một',
                    COMPANY_ID: 'd25b7e6246444814ace090a00b07855b'
                },
                SDC: {
                    COMPANY_NAME: 'Công ty TNHH SDC',
                    COMPANY_ID: '25d1d93a219440169476db2d1cce9f31'
                }
            }
        };
    },
};

Vue.use(ConstPlugin);



// WEBPACK FOOTER //
// ./src/plugins/const_plugin.js